import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../utils/context';

export default Comp => () => {
  const { i18n } = useTranslation();
  const { localeData } = useContext(AppContext);

  useEffect(() => {
    if (i18n.language !== localeData.loadedLanguage.code) {
      i18n.changeLanguage(localeData.loadedLanguage.code);
    }
  }, [localeData.loadedLanguage.code]);

  return <Comp />;
}
